<template>
  <b-link class="link-main" v-if="userAuth.validation.validationUpdate" :to="'/' + path + '/' + id">
    <t-table-field :formatter="formatter" :label="label"/>
  </b-link>
  <span v-else>
    <t-table-field :formatter="formatter" :label="label"/>
  </span>
</template>
<script>


export default {
  name: 't-list-link-primary',
  data() {
    return {}
  },
  props: {
    userAuth: {
      type: Object,
      required: true
    },
    path: {
      type: String,
      required: true
    },
    id: {
      type: Number,
      required: true
    },
    label: {
      type: [String, Number],
      required: true
    },
    formatter: {
      type: String,
      default: "",
    },
  },
  methods: {


    async editItem() {

      //console.log(this.$route.query)

    }

  }
}
</script>
